import React from 'react';
import ChessDisplay from '../components/ChessDisplay';
import AdventureFeedCarousel from '../components/AdventureFeedCarousel';
import { latestResearchPublication } from './researchPublications';

export const initialPosts = [
  {
    id: 5,
    type: 'blog',
    title: 'Climbing Glacier Peak',
    date: 'Aug 24, 2026',
    content: `Read the summit post (link below)...`,
    component: <AdventureFeedCarousel trackId="glacier-peak" trackUrl="/tracks/glacier-peak.gpx" />,
    link: 'https://www.summitpost.org/glacier-peak-august-2026/1103557',
    linkText: 'Summit Post'
  },
  {
    id: 2,
    type: 'research',
    title: latestResearchPublication.title,
    date: `Published in ${latestResearchPublication.year}`,
    content: latestResearchPublication.description,
    skills: latestResearchPublication.tags,
    link: latestResearchPublication.pdf,
    linkText: 'Read Paper'
  },
  {
    id: 2.5,
    type: 'research',
    title: 'Development of a Novel Foundation Prior for Physics-Informed Reinforcement Learning',
    date: 'Published in 2025',
    content: 'This project develops a physics-informed foundation prior using a U-Net trained on fluid simulations. Using this prior improves reinforcement learning performance and training efficiency on physics-based tasks.',
    skills: ['PIRL', 'CNN', 'RL'],
    link: '/research/Development_of_Novel_Foundation_Prior_PIRL.pdf',
    linkText: 'Read Paper'
  },
  {
    id: 5.1,
    type: 'blog',
    title: 'Mt. Hood Summit',
    date: 'Jul 2026',
    content: 'An incredible climb up the volcanic slopes of Mt. Hood in Oregon.',
    component: <AdventureFeedCarousel trackId="mt-hood" trackUrl="/tracks/mt-hood.gpx" />
  },
  {
    id: 4,
    type: 'chess',
    title: 'Chess Progress Dashboard',
    date: 'Live Tracker',
    content: 'I love playing chess in my free time. Here is a live dashboard tracking my Rapid Elo on Chess.com over the last three months, along with my recent game results.',
    component: <ChessDisplay />
  },
  {
    id: 5.2,
    type: 'blog',
    title: 'Eldorado Peak Mountaineering',
    date: 'May 2026',
    content: 'Tackling the knife-edge ridges of Eldorado Peak.',
    component: <AdventureFeedCarousel trackId="eldorado-peak" trackUrl="/tracks/eldorado-peak.gpx" />
  },
  {
    id: 3,
    type: 'project',
    title: 'Boilermake Hackathon (Top 5)',
    date: 'Fall 2025',
    content: 'Built a set of low-cost sensor devices communicating over a WiFi mesh network with an extended range of 600–700 ft — ideal for large-scale agricultural deployments spanning thousands of acres. Developed a deployment algorithm using satellite imagery to optimize node placement.',
    image: '/groupphoto.jpg',
    skills: ["Arduino IDE", "React.js", "Embedded Software", "Soldering"]
  },
  {
    id: 5.3,
    type: 'blog',
    title: 'Saturday Hike to Cask Lake',
    date: 'Sep 2026',
    content: 'A quick weekend hike up to the beautiful alpine waters of Cask Lake.',
    component: <AdventureFeedCarousel trackId="cask-lake" trackUrl="/tracks/cask-lake.gpx" />
  }
];
